import { routerFrom } from "router";

export const routes = [
  {
    acl: [],
    label: "Job Request Detail",
    name: "job-requests.detail",
    path: "/app/job-requests/:jobRequestId",
    testName: "job-requests-detail",
  },
  {
    acl: [],
    label: "Job Requests",
    name: "job-requests",
    path: "/app/job-requests",
    testName: "job-requests-list",
  },
];

export const router = routerFrom(routes);
